import { TRAVEL_DIRECTIONS } from "@seagames/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { LogisticsDeskPage } from "../../components/logistics-desk/desk-page";
import { DESK_VIEWS } from "../../lib/api/logistics-desk";
import { canSeeTravel } from "../../lib/travel/access";

const lenient = <T extends z.ZodTypeAny>(schema: T) => schema.optional().catch(undefined);

/**
 * `/logistics/desk` — the Logistics desk (Sector 3, user 2026-10-31): the
 * host's day of the travel chain, Travel → Transfer → Room per person.
 * Who: whoever reads travel (admins, `logistics.travel` / `travel_review`
 * groups), never a NOC — a NOC has its own pages. A courtesy, not the
 * control: the API scopes every row in SQL.
 */
export const Route = createFileRoute("/_app/logistics/desk")({
	validateSearch: z.object({
		games_id: lenient(z.string().uuid()),
		date: lenient(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)),
		direction: lenient(z.enum(TRAVEL_DIRECTIONS)),
		view: lenient(z.enum(DESK_VIEWS)),
		org: lenient(z.string().uuid()),
		q: lenient(z.string().trim().max(100)),
	}),
	beforeLoad: ({ context }) => {
		if (!canSeeTravel(context.session) || context.session.active_role === "ORGANIZATION") throw redirect({ to: "/" });
	},
	staticData: { contentWidth: "full" },
	component: DeskRoute,
});

function DeskRoute() {
	const { session } = Route.useRouteContext();
	return <LogisticsDeskPage session={session} search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
